// eslint-disable-next-line no-shadow
enum PosStatus {
  STOCK,
  USE,
  RESERVED,
  INACTIVE,
}
export default PosStatus;
